function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "24",
  viewBox: "0 0 18 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.002 2.435c3.541 0 6.546 2.933 6.546 6.408 0 3.292-2.53 5.547-3.748 6.634l-.33.298a13.667 13.667 0 00-2.458 3.004c-.62-1.046-1.487-2.102-2.457-3.004-.093-.093-.207-.185-.33-.298-1.219-1.087-3.748-3.342-3.748-6.634-.02-3.475 2.984-6.408 6.525-6.408zM0 8.828c0 4.859 3.924 7.903 5.248 9.12 1.753 1.608 3.102 3.641 3.593 5.224a.165.165 0 00.318 0c.479-1.583 1.84-3.616 3.593-5.223C14.076 16.73 18 13.687 18 8.829 18 3.92 13.794 0 9 0S0 3.92 0 8.828zm9 2.18a2.224 2.224 0 002.232-2.216A2.224 2.224 0 009 6.575a2.216 2.216 0 00-2.232 2.217A2.224 2.224 0 009 11.008z",
  fill: "currentColor",
  fillRule: "evenodd"
})));